import { render, staticRenderFns } from "./ticketCreateInfo.vue?vue&type=template&id=645210d4&scoped=true&"
import script from "./ticketCreateInfo.vue?vue&type=script&lang=js&"
export * from "./ticketCreateInfo.vue?vue&type=script&lang=js&"
import style0 from "./ticketCreateInfo.vue?vue&type=style&index=0&id=645210d4&lang=scss&scoped=true&"
import style1 from "./ticketCreateInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645210d4",
  null
  
)

export default component.exports